module.exports = __webpack_public_path__ + "static/media/1-6.b57ffeaa.PNG";